const rawApiBase = (process.env.REACT_APP_API_URL || '').trim();
const normalizedApiBase = rawApiBase ? rawApiBase.replace(/\/+$/, '') : '';

function getFallbackApiBase() {
  if (typeof window === 'undefined') return 'http://localhost:5000';

  const host = String(window.location.hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return 'http://localhost:5000';

  if (host === 'app.interiorfolio.com' || host.endsWith('.interiorfolio.com')) {
    return 'https://interiorfolio.onrender.com';
  }

  return window.location.origin;
}

const withFallback = normalizedApiBase || getFallbackApiBase();
const API_BASE = /^https?:\/\//i.test(withFallback) ? withFallback : `https://${withFallback}`;

export default API_BASE;
